import { __assign, __makeTemplateObject, __rest } from "tslib";
/**@jsx jsx */

import { useState } from 'react';
import { css, jsx } from '@emotion/react';
import { View } from './View';
import { Text } from './Text';
import { Card } from './Card';
import { useTheme } from './theme/Providers';

var Collider = function Collider(_a) {
  var title = _a.title,
      content = _a.content,
      children = _a.children,
      isMobileScreen = _a.isMobileScreen,
      titleColor = _a.titleColor,
      iconColor = _a.iconColor,
      id = _a.id,
      other = __rest(_a, ["title", "content", "children", "isMobileScreen", "titleColor", "iconColor", "id"]);

  var theme = useTheme();

  var _b = useState(false),
      open = _b[0],
      setOpen = _b[1];

  var _c = useState(false),
      delayOpen = _c[0],
      setDelayOpen = _c[1];

  var realIconColor = iconColor ? iconColor : theme.colors.scales.blue[5];
  var realTitleColor = titleColor ? titleColor : theme.colors.scales.blue[5];
  var containerDividerStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    width: 1rem;\n    height: 1rem;\n    margin: 0.213rem 0 0;\n  "], ["\n    position: relative;\n    width: 1rem;\n    height: 1rem;\n    margin: 0.213rem 0 0;\n  "])));
  var divider1Style = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    width: 1rem;\n    height: 0.125rem;\n    top: 0.5rem;\n    right: 0;\n    background-color: ", ";\n  "], ["\n    position: absolute;\n    width: 1rem;\n    height: 0.125rem;\n    top: 0.5rem;\n    right: 0;\n    background-color: ", ";\n  "])), realIconColor);
  var divider2Style = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    width: 0.125rem;\n    height: 1rem;\n    top: 0.063rem;\n    right: 0.438rem;\n    background-color: ", ";\n  "], ["\n    position: absolute;\n    width: 0.125rem;\n    height: 1rem;\n    top: 0.063rem;\n    right: 0.438rem;\n    background-color: ", ";\n  "])), realIconColor);
  var growStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    -moz-transition: height .5s;\n    -ms-transition: height .5s;\n    -o-transition: height .5s;\n    -webkit-transition: height .5s;\n    transition: height .5s;\n    height: 0;\n    overflow: hidden;\n  "], ["\n    -moz-transition: height .5s;\n    -ms-transition: height .5s;\n    -o-transition: height .5s;\n    -webkit-transition: height .5s;\n    transition: height .5s;\n    height: 0;\n    overflow: hidden;\n  "])));
  var titleStyle = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    margin: 0 2.5rem 0 0;\n  "], ["\n    color: ", ";\n    margin: 0 2.5rem 0 0;\n  "])), realTitleColor);
  var mainCollapserStyle = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n  "])));
  var contentStyle = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    box-sizing: border-box;\n    margin: ", ";\n    color: ", ";\n  "], ["\n    box-sizing: border-box;\n    margin: ", ";\n    color: ", ";\n  "])), !delayOpen ? '0' : '1.5rem 0 0', theme.colors.scales.gray[11]);
  var realId = id;
  var realIdContainer = id + "-container";
  var realIdButton = id + "-button";

  var growDiv = function growDiv() {
    var growingDiv = window.document.getElementById(realId);

    if (growingDiv === null || growingDiv === void 0 ? void 0 : growingDiv.clientHeight) {
      growingDiv.style.height = '0rem';
      setTimeout(function () {
        setDelayOpen(false);
      }, 500);
    } else {
      var wrapper = window.document.getElementById(realIdContainer);
      var sum = (Number(wrapper === null || wrapper === void 0 ? void 0 : wrapper.clientHeight) + 24) / 16;
      growingDiv.style.height = sum + 'rem';
      setDelayOpen(true);
    }
  };

  var handleToggle = function handleToggle() {
    setOpen(!open);
    growDiv();
  };

  return jsx(Card, __assign({}, other, {
    variant: 'collider'
  }), jsx(View, {
    id: realIdButton,
    onClick: handleToggle,
    css: mainCollapserStyle
  }, jsx(Text, {
    variant: isMobileScreen ? 'subtitle' : 'h6',
    css: titleStyle
  }, title), jsx(View, {
    css: containerDividerStyle
  }, jsx(View, {
    css: divider1Style
  }), !open ? jsx(View, {
    css: divider2Style
  }) : null)), jsx(View, {
    css: growStyle,
    id: realId
  }, jsx(View, {
    id: realIdContainer
  }, children ? jsx(View, {
    css: contentStyle
  }, children) : jsx(Text, {
    variant: 'paragraph',
    css: contentStyle
  }, content))));
};

export { Collider };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;